import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';

const StyledDimensionValue = styled.div<{
  small?: boolean;
  bold?: boolean;
  noBackground?: boolean;
}>`
  background: white;
  margin-right: 5px;
  font-size: 1.1rem;
  padding-left: 1px;

  ${p =>
    p.noBackground &&
    css`
      background: none;
    `}

  ${p =>
    p.small &&
    css`
      font-size: 0.8rem;
    `}

  ${p =>
    p.bold &&
    css`
      font-weight: bold;
    `}
`;

export default StyledDimensionValue;
